require('../../pricing/plans/plansService');
require('../../fhApp/currentUser/currentUser');
require('../../fhApp/serviceBreakerService');
require('../../shared/teamService');
require('../../fhApp/productService');

"use strict";

angular.module('app.purchase.purchaseForm.purchaseFormController', [
  'app.pricing.plans.plansService',
  'app.currentUser',
  'app.serviceBreakerService',
  'app.shared.teamService',
  'app.productService'
])
  .controller('app.purchase.purchaseForm.purchaseFormController', [
    '$scope',
    'app.pricing.plans.plansService',
    'currentUser',
    'app.serviceBreakerService',
    'app.shared.teamService',
    '$timeout',
    '$filter',
    '$rootScope',
    'app.productService',
    'PRODUCT',
    function ($scope, pricingPlans, currentUser, serviceBreakerService, teamService, $timeout, $filter, $rootScope, productService, PRODUCT) {
      //$scope variables assigned through directive
      $scope.showManage = $scope.showManage || false;
      $scope.currentSubscription = $scope.currentSubscription || null;
      $scope.plans = $scope.plans || null;
      $scope.fetchPlans = $scope.fetchPlans || false;
      $scope.fetchSubscription = $scope.fetchSubscription || false;
      $scope.useServiceBreaker = $scope.useServiceBreaker || false;
      $scope.groupedPlans = $scope.groupedPlans || { commonPlanAttrs: {}, plans: [] };

      //$scope variables used primarily for html view
      $scope.breakers = serviceBreakerService.breakers;
      $scope.planCards = [];

      let teams = [];
      let currentSubscriptionWatcher = null;
      let plansWatcher = null;
      let timer;

      let buildPlanCards = () => {
        let planCards = [];

        sortPlans();

        if ($scope.currentSubscription) {
          if (($scope.currentSubscription.subscription_upgrades && $scope.currentSubscription.state === 'active' &&
            !$scope.currentSubscription.pause_scheduled && !$scope.currentSubscription.is_future) ||
            ($scope.currentSubscription.state === 'canceled' && productService.isSubscriptionUpgradeableIfCancelled())) {
            let plans = [];
            let upgradeablePlanCodes = $scope.currentSubscription.subscription_upgrades;

            if ($scope.currentSubscription.state === 'active' && upgradeablePlanCodes) {
              _.forEach($scope.plans, (plan) => {
                if (upgradeablePlanCodes.indexOf(plan.plan_code) > -1) {
                  plans.push(plan)
                }
              });
            } else if ($scope.currentSubscription.state === 'canceled' && productService.isSubscriptionUpgradeableIfCancelled()) {
              _.forEach($scope.plans, (plan) => {
                if ($scope.currentSubscription.plan.plan_code !== plan.plan_code) {
                  plans.push(plan)
                }
              });
            }

            planCards.push({
              cardType: 'upgrade',
              currentSubscription: $scope.currentSubscription,
              planTeams: teams,
              plans: plans,
            });
          }

          if ($scope.currentSubscription.state === 'paused') {
            planCards.push({
              currentSubscription: $scope.currentSubscription,
              cardType: 'resume'
            });
          }

          if ($scope.currentSubscription.state === 'canceled'
          ) {
            planCards.push({
              currentSubscription: $scope.currentSubscription,
              cardType: 'renew'
            });
          }

          /*if (!$scope.currentSubscription.subscription_upgrades && productService.cannotUpgradeSubscription()) {
            let invalidUpgradeIndex = planCards.findIndex((subscription_plan) => {
              return subscription_plan.cardType === 'cannot-upgrade'
            });

            if (invalidUpgradeIndex <= -1) {
              planCards.push({
                plan: $scope.currentSubscription.plan,
                cardType: 'cannot-upgrade'
              });
            }
          }*/

          if ($scope.currentSubscription.state === 'active'
            && !$scope.currentSubscription.paused && $scope.currentSubscription.plan_code != "access_pass"
          ) {
            planCards.push({
              currentSubscription: $scope.currentSubscription,
              cardType: 'cancel'
            });
          }

          if ($scope.currentSubscription.state === 'active'
            && !$scope.currentSubscription.paused
            && !$scope.currentSubscription.is_future
            && $scope.currentSubscription.can_be_paused
            && !$scope.currentSubscription.pause_scheduled
          ) {
            planCards.push({
              currentSubscription: $scope.currentSubscription,
              cardType: 'pause'
            });
          }

          if ($scope.currentSubscription.state === 'active'
            && $scope.currentSubscription.pause_scheduled
          ) {
            planCards.push({
              currentSubscription: $scope.currentSubscription,
              cardType: 'scheduled_pause'
            });
          }
        } else {
          if ($scope.groupedPlans.plans.length) {
            let singlePlans = $scope.plans.filter(plan => !$scope.groupedPlans.plans.some(other => plan.plan_code === other.plan_code));

            _.forEach(singlePlans, (plan) => {
              planCards.push({
                plan: plan,
                cardType: 'singlePlan',
                useTeams: productService.planUsesTeams(plan),
                planTeams: teams,
              });
            });

            planCards.push({
              cardType: 'multiPlan',
              useTeams: productService.planUsesTeams($scope.groupedPlans.plans[0]),
              planTeams: teams,
              commonPlanAttrs: $scope.groupedPlans.commonPlanAttrs,
              plans: $scope.groupedPlans.plans
            });

          } else {
            _.forEach($scope.plans, (plan) => {
              planCards.push({
                plan: plan,
                cardType: 'singlePlan',
                useTeams: productService.planUsesTeams(plan),
                planTeams: teams,
              });
            });
          }
        }

        if ($scope.showManage && $scope.currentSubscription && $scope.currentSubscription.plan_code != "access_pass") {
          planCards.push({
            cardType: 'manageBilling',
            currentSubscription: $scope.currentSubscription,
          });
        }

        $scope.planCards = planCards;
      };

      let sortPlans = () => {
        return _.sortBy($scope.plans, ['type', 'unit_price']);
      };

      let init = () => {
        if (productService.useTeamSubscriptions()) {
          teamService.getTeams().then(
            function (response) {
              let data = response.data;

              if (data) {
                if (data.error) {
                  alert(data.error)
                } else {
                  teams = data;
                  startWatchers();
                }
              }
            }
          );
        } else {
          startWatchers();
        }

        checkBreaker();
      };

      let checkBreaker = () => {
        if ($scope.useServiceBreaker) {
          serviceBreakerService.checkRecurly()
            .then(() => {
              timer = $timeout(
                () => {
                  checkBreaker();
                },
                60000
              );
            });
        }
      };

      let startWatchers = () => {
        currentSubscriptionWatcher = $scope.$watch(() => {
          return $scope.currentSubscription;
        }, () => {
          let alreadyPrepped = false;

          if ($scope.fetchSubscription && !$scope.currentSubscription) {
            currentUser.get_current_subscriptions('recurly').then(() => {
              buildPlanCards();
              alreadyPrepped = true;
            });
          }

          if (!alreadyPrepped) {
            buildPlanCards();
          } else {
            alreadyPrepped = false;
          }
        });

        plansWatcher = $scope.$watch(() => {
          return $scope.plans;
        }, () => {
          let alreadyPrepped = false;

          if ($scope.fetchPlans && !$scope.plans) {
            pricingPlans.retrieve(null, { sort: 'active' }).then(() => {
              $scope.plans = pricingPlans.list;
              buildPlanCards();
              alreadyPrepped = true;
            });
          }

          if ($scope.plans && !alreadyPrepped) {
            buildPlanCards();
          }

          if (alreadyPrepped) {
            alreadyPrepped = false;
          }
        });
      };

      $scope.$on('$destroy', function () {
        $timeout.cancel(timer);
      });

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/purchase/purchaseForm/purchaseFormController.js